<div class="modal-content">
    <!-- HEADER Of POPUP STARTS -->
    <div class="modal-header" id="create-story-modal-header">
      <div style="display: flex; width: 100%;">
        <div class="col-10 col-lg-10">
          <h5 class="modal-title" title="add-discussion">Create Story</h5>
        </div>
        <div class="col-2 col-lg-2">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal({})">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>

    <!-- BODY Of POPUP STARTS -->
    <div class="modal-body">
        <div class="modal-info" id="create-story-modal-body">
            <div class="post-type-tabs">

                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-newpost" role="tabpanel" aria-labelledby="pills-newpost-tab">
                        <div class="add-post-inputbox">
                            <form [formGroup]="storyForm">
                                <div>
                                    <div class="col-md-8">
                                        <ul class="list-inline  mb-0 d-flex align-items-center h-100">
                                            <li class="list-inline-item">
                                                <input type="file" id="story-files" (change)="imagePreview($event)" formControlName="fileUpload" style="display:none;" #fileUpload>
                                                <div class="text-dark" style="cursor: pointer; display: inline-table;" (click)="fileUpload.click()"><img src="assets/images/attachment-icon.svg" alt="attachment" class="mr-2"> Upload Photo </div>
                                                <div class="img-preview" *ngIf="filePath && filePath !== ''">
                                                    <div class="slide-story pb-2"><img [src]="filePath" [alt]="storyForm.value.name"></div>
                                                    <div class="remove-icon"><i class="fa fa-remove" style="font-size:24px;color:red" (click)="removeFile()"></i></div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="form-group">
                                        <textarea placeholder="Enter the Story Desciption here... (Optional)" maxlength='50' id="storyDescription" formControlName="storyDescription" class="form-control" rows="3"></textarea>
                                    </div>
                                </div>
                                <div class="form-group p-0 mt-4">
                                  <div class="col-md-4 col-12">
                                    <label for="txt" class="font-avbold">Choose Story Title Color</label>
                                  </div>
                                  <div class="col-md-8 col-12 d-flex p-1" style="flex-wrap: wrap;">
                                    <div class="radio-group" *ngFor="let colorCollection of colorCollections; let i = index">
                                      <div class="p-1 color-group radio" [attr.data-value]="colorCollection.color_name" [ngClass]="{selected: selectedIndex === i}" (click)="setIndex(i)">
                                          <div class="color-circle" [ngStyle]="{'background-color': colorCollection.color_code}" (click)="colorSelction(colorCollection.color_code)"></div>
                                      </div>
                                  </div>
                                  </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="form-group p-0 mt-4 pl-3">
                                        <span class="text-danger bold" *ngIf="storyForm.controls['storyDescription'].hasError('customValidator')">Please select atleast image or story title</span>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                  <div class="form-group p-0 mt-4 pl-3">
                                      <span class="text-danger bold" *ngIf="showSupportText">Please upload supported image formats [png,jpg,jpeg]</span>
                                  </div>
                              </div>
                                <div class="row mt-3">

                                    <div class="col-md-12 text-right">
                                        <button class="btn btn-previous mr-2" data-dismiss="modal" data-toggle="modal" data-target="#" (click)="open('section2')" [disabled]="!storyForm.valid">Preview</button>
                                        <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-toggle="modal" (click)="submitStory()" [disabled]="!storyForm.valid || isSubmit">Share Story</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="modal-content">
    <div class="modal-header" id="preview-story-modal-header" style="display: none;">
      <div style="display: flex; width: 100%;">
        <div class="col-10 col-lg-10">
          <h5 class="modal-title" title="add-discussion">Story Preview</h5>
        </div>
        <div class="col-2 col-lg-2">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal({})">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        </div>

    </div>
    <!-- BODY Of POPUP STARTS -->
    <div class="modal-body">
        <div class="modal-info" id="preview-story-modal-body" style="display: none;">
            <div class="post-type-tabs">

                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-newpost" role="tabpanel" aria-labelledby="pills-newpost-tab">
                        <div class="add-post-inputbox">
                            <div class="row mt-3">
                                <div class="col-md-12 text-center">
                                    <div class="preview-story-img" *ngIf="filePath && filePath !== ''" style="max-height: 50vh;">
                                        <img [src]="filePath" alt="storyForm.value.name" style="max-width: 100%; max-height: 50vh;">

                                    </div>
                                    <div class="preview-story-txt" *ngIf="storyTitle && storyTitle !==''"><span [ngStyle]="{color: storyTitleColor}">{{storyTitle}}</span></div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-12 text-center">
                                    <button class="btn btn-previous mr-2" data-dismiss="modal" data-toggle="modal" data-target="#" (click)="open('section1')">Back</button>
                                    <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-toggle="modal" (click)="submitStory()" [disabled]="!storyForm.valid">Share Story</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
